module.exports = __webpack_public_path__ + "img/weekly-4.9877102f.png";